const METER_REPLACEMENT_NOTIFICATION = '2021MeterUpgradeProjectCaseOpen';
const RTU_METER_REPLACEMENT_NOTIFICATION = 'RTU2021MeterUpgradeProjectCaseOpen';

export { METER_REPLACEMENT_NOTIFICATION, RTU_METER_REPLACEMENT_NOTIFICATION };
